'use client'

import React, { FC, ReactElement } from 'react'

import ButtonGradientEpic from '@/components/button-gradient-epic'

const SendReceive: FC<{
	onClickReceive?: () => void
	onClickSend?: () => void
	className?: string
}> = (props): ReactElement => {
	const { className } = props

	const handleClickReceive = React.useCallback(
		() => props?.onClickReceive && props.onClickReceive(),
		[props]
	)

	const handleClickSend = React.useCallback(
		() => props?.onClickSend && props.onClickSend(),
		[props]
	)

	return (
		<div className={`w-full grid grid-cols-2 justify-center gap-3 ${className || ''}`}>
			<ButtonGradientEpic
				className="w-full py-3"
				type="submit"
				onClick={handleClickSend}
				size="small"
			>
				Send
			</ButtonGradientEpic>
			<ButtonGradientEpic
				className="w-full py-3"
				type="submit"
				onClick={handleClickReceive}
				size="small"
			>
				Receive
			</ButtonGradientEpic>
		</div>
	)
}

export default SendReceive
